module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1afd0fa592eb25f2d26173c78211acc4.png";